export default __webpack_public_path__ + "static/banner-real-stories-saving-spending-lending-ann-724009492f114f0adb7e59fda29f6bc8.jpg";